const globalColors = {
    texts: {
        grayed: 'rgba(98, 98, 98, 0.4)',
        strong: 'rgba(98, 98, 98, 0.8)',
        strongHovered: 'rgba(98, 98, 98, 1)',
        inputText: 'rgba(98, 98, 98, 0.5)',
        disabledGray: '#93949980',
        activeGray: '#626262'
    },
    backgrounds: {
        white: '#FFF',
        lightPurple: '#EFE9FB',
        medPurple: '#BAA7D8',
        darkPurple: '#A588D2',
        purple: '#BAA7D8',
        pinkGradient:
            'linear-gradient(83deg, rgba(226, 216, 247, 0.40) 2.82%, rgb(242 125 177 / 15%) 30%, rgb(242 125 177 / 3%) 50%, rgb(242 125 177 / 15%) 70%, rgba(226, 216, 247, 0.40) 94.71%)',
        grayedLightPurple: 'linear-gradient(129deg, rgba(231, 231, 245, 0.7) -25.34%, #fdfdfd 62.35%)'
    },
    borders: {
        grayed: 'rgba(98, 98, 98, 0.2)',
        strong: 'rgba(242, 125, 177, 0.2)',
        strongHovered: 'rgba(242, 125, 177, 0.3)',
        darkPurple: 'rgba(122, 110, 157, 1)',
        lightPurple: 'rgba(239, 233, 251, 1)',
        input: 'rgba(226, 216, 247, 0.4)'
    }
};

export default globalColors;
